import React from 'react';
import { useStyles } from './styles';
import {
  Modal,
  Icon,
  Typography,
  Button,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import { Formik, Field, Form, FieldArray } from 'formik';
import SearchInput from 'shared/component/forms/SearchInput';
import FilterCheckBox from './FilterCheckBox';
import useScales from 'hook/scales';

export default function FilterShiftsModal({
  openFilter,
  handleClose,
  filterModal,
  selectedScaleList,
  setSelectedScaleList,
  setFilterModal,
  setFilterType,
  unitId,
  unitIds = [],
}) {
  const { scalesFilter, getFilterScales, getScalesByUnitIds } = useScales();

  const { dataScalesFilter, loadingScales, totalScales } = scalesFilter;

  const [stateScales, setStateScales] = React.useState([]);
  const [scaleFilter, setScaleFilter] = React.useState({
    scalePage: 1,
    scalePerPage: 100,
    scaleSearch: '',
  });
  const { scalePage, scalePerPage, scaleSearch } = scaleFilter;
  const totalScalePage = Math.ceil(totalScales / scalePerPage);
  const initialValues = { situationStatus: '', scales: [] };
  const classes = useStyles();
  const [clearFilters, setClearFilters] = React.useState(false);

  const getInitialScales = () => {
    setStateScales([
      ...dataScalesFilter.map((item) => ({
        id: item.id,
        name: item.name,
        checked: selectedScaleList.find((custom) => custom.id === item.id)
          ? true
          : false,
      })),
    ]);
  };

  React.useEffect(() => {
    getInitialScales();
  }, [dataScalesFilter, unitId, openFilter, selectedScaleList]);

  const onClearFilter = (status) => setClearFilters(status);

  const clearAllFilters = () => {
    setClearFilters(true);
  };

  React.useEffect(() => {
    if (!openFilter) return;
    setScaleFilter((prev) => ({
      ...prev,
      scalePage: 1,
      scaleSearch: '',
    }));
  }, [unitId, openFilter]);

  React.useEffect(() => {
    if (!openFilter || !unitId) return;
    getFilterScales(
      scalePage,
      scalePerPage,
      unitId,
      null,
      null,
      null,
      scaleSearch,
      1
    );
  }, [openFilter, scalePage, scalePerPage, scaleSearch, unitId]);

  React.useEffect(() => {
    if (!openFilter || unitId !== null || unitIds.length === 0) return;
    getScalesByUnitIds({
      unitIds,
      page: scalePage,
      perPage: scalePerPage,
      search: scaleSearch,
      status: 1,
    });
  }, [openFilter, scalePage, scalePerPage, scaleSearch, unitId, unitIds]);

  const onScrollBottom = (event) => {
    const bottom =
      event.currentTarget.scrollHeight - event.currentTarget.scrollTop ===
      event.currentTarget.clientHeight;

    if (bottom && !loadingScales && scalePage < totalScalePage) {
      setScaleFilter({ ...scaleFilter, scalePage: scalePage + 1 });
      event.currentTarget.scrollTop = 3;
    }
    if (event && event.currentTarget.scrollTop === 0 && scalePage > 1) {
      setScaleFilter({ ...scaleFilter, scalePage: scalePage - 1 });
    }
  };

  const onFilter = (data) => {
    if (data.scales && data.scales.length > 0) {
      setFilterType('custom');
      const scaleDetailsList = data.scales
        .map((scaleId) => parseInt(scaleId, 10))
        .map((scaleId) => dataScalesFilter.find((item) => item.id === scaleId))
        .filter(Boolean);

      setSelectedScaleList(scaleDetailsList);
    }
    if (data.scales.length === 0) {
      setFilterType('universal');
      setSelectedScaleList([]);
    }
    setFilterModal(!filterModal);
  };

  const handleSearch = (e) => {
    const busca = e.target.value;
    setScaleFilter({ ...scaleFilter, scaleSearch: busca });
  };
  const debounce = function (fn, d) {
    let timer;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, d);
    };
  };
  const debounceForData = debounce(handleSearch, 500);

  return (
    <Modal
      className={classes.modal}
      open={openFilter}
      onClose={handleClose}
      disableAutoFocus
      disableEnforceFocus
    >
      <Paper className={classes.paperContainer}>
        <div className={classes.divPadding}>
          <div>
            <div className={classes.rowContainer}>
              <Icon className={classes.iconStyles}>filter_alt</Icon>
              <Typography className={classes.titleStyles}>Filtros</Typography>
            </div>
          </div>
          <Formik onSubmit={onFilter} initialValues={initialValues}>
            {({ values }) => (
              <Form>
                <div className={classes.rowPadding}>
                  <div className={classes.leftContainer}>
                    <SearchInput
                      onChange={debounceForData}
                      dividerOn
                      placeholder="Busque as escalas"
                    />
                    <div
                      className={classes.scrollContainer}
                      onScroll={onScrollBottom}
                    >
                      <FieldArray
                        name="scales"
                        render={(arrayHelp) => (
                          <div>
                            {!loadingScales &&
                              stateScales &&
                              stateScales.length > 0 &&
                              stateScales.map((option) => (
                                <div key={option.id} style={{ width: '100%' }}>
                                  <Field
                                    hospitais={values.scales}
                                    arrayhelp={arrayHelp}
                                    arraychecked={selectedScaleList}
                                    setarraychecked={setSelectedScaleList}
                                    name="scales.id"
                                    id={option.id.toString()}
                                    label={option.name}
                                    checkedprops={option.checked}
                                    clearfilters={clearFilters.toString()}
                                    setfiltertype={setFilterType}
                                    onclearfilters={onClearFilter}
                                    component={FilterCheckBox}
                                  />
                                </div>
                              ))}
                            {loadingScales && (
                              <div className={classes.loadingContainer}>
                                <CircularProgress />
                              </div>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className={classes.closeBar}>
                  <Button onClick={clearAllFilters}>
                    <Icon style={{ fontSize: 21, color: '#A2A5A8' }}>
                      close
                    </Icon>
                    <Typography className={classes.clearAllText}>
                      Limpar todos
                    </Typography>
                  </Button>
                  <Button className={classes.filterButton} type="submit">
                    <Typography className={classes.filterText}>
                      Filtrar
                    </Typography>
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Paper>
    </Modal>
  );
}
